export default __webpack_public_path__ + "static/media/curriculum-uploaded.1e98202d.svg";